<template lang="pug">
  v-layout(align-start)
    v-card.pa-7(width='96vw' outlined)
      h1(align='left') Reporte de Gerencia
        v-row(dense)
          v-col(cols='6' sm='6' md='6')
            v-text-field(v-model='fechaDesde' label='Desde' prepend-icon='event' readonly dense outlined)
            //- v-dialog(ref='dialog1', v-model='modalDate1', :return-value.sync='date', readonly, persistent, width='300px')
              template(v-slot:activator='{ on }')
                v-text-field(v-model='fechaDesde' label='Desde' prepend-icon='event' readonly dense outlined v-on='on')
              v-date-picker( v-model='fechaDesde' locale="ES")
                v-spacer
                v-btn(small, dark, color='danger,' @click='modalDate1 = false') Cancelar
                v-btn(small, dark, color='success', @click='$refs.dialog1.save(date)') Ok
          v-col(cols='6' sm='6' md='6')
            v-text-field( v-model='fechaHasta' label='Hasta' prepend-icon='event' readonly dense outlined)
            //- v-dialog( ref='dialog2', v-model='modalDate2', :return-value.sync='date', readonly, persistent, width='300px')
              template(v-slot:activator='{ on }')
                v-text-field( v-model='fechaHasta' label='Hasta' prepend-icon='event' readonly dense outlined v-on='on')
              v-date-picker( v-model='fechaHasta' locale="ES")
                v-spacer
                v-btn(small dark color='danger' @click='modalDate2 = false') Cancelar
                v-btn(small dark color='success' @click='$refs.dialog2.save(date)') Ok
        v-row(dense class='d-flex justify-center mb-10')
          v-btn(@click='getReporte' color='primary' dark) Generar
    v-dialog(v-model='dialog' scrollable persistent min-width="90%")
      v-card
        v-card-text
          v-container(id="reporteLibro")
            v-row(dense)
              v-col(cols=6)
                p(style="margin-bottom: 2%; color: black;") {{nameEmpresa}}
                p(style="margin-bottom: 2%; color: black;") RIF:
              v-col(cols=6)
                p(style="text-align: end; margin-bottom: 2%; color: black;") Fecha: {{ date }}
                p(style="text-align: end; margin-bottom: 2%; color: black;") Hora: {{ hora }}
            v-row(align="center" justify="center")
              v-col(cols="12" sm="4")
                h4(style="text-align: center; text-decoration: underline black; color: black;") LIBRO DE VENTAS I.V.A.
            v-row(dense)
              v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
                v-row(dense)
                  v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
                    p(style="color: black;") Desde:
                    p(style="color: black;") Hasta:
                    p(style="color: black;") Descripción:
                    p(style="color: black;") Condiciones:
                  v-col(cols=6, xs=6, sm=6, md=6, lg=6, xl=6)
                    p(style="color: black") {{this.formato(fechaDesde)}}
                    p(style="color: black") {{this.formato(fechaHasta)}}
                    p(style="color: black") I.V.A(%)
                    p(style="color: black") Contado/Crédito
            v-row(dense)
              v-data-table(:headers="headerVentas", :items="transaccionesDias.array || []", dense, disable-sort, hide-default-footer, style="width: 100%" )
                template(v-slot:body.append)
                  tr
                    th
                    th
                    th
                    th
                    th
                    th
                    th
                    th(style="border-top: 1px solid black;") {{transaccionesDias.totalIncluyendoIVA}}
                    th(style="border-top: 1px solid black;") 0.00
                    th(style="border-top: 1px solid black;") {{transaccionesDias.totalBaseImponible}}
                    th
                    th(style="border-top: 1px solid black;") {{transaccionesDias.totalImpuesto}}
                    th(style="border-top: 1px solid black;") 0.00
                template(v-slot:no-data='')
                  h3 No hay datos asociados
            p
            v-row(dense)
              v-col(cols=12)
                p(style="color: black; text-align: end") Total Operaciones: {{libroVentas.totalTransacciones}}
            v-row(dense)
              table(style="margin-left: 40%")
                tr
                  td
                  th(style="text-align: center; padding: 0.3em; color: black; background: lightgray") Base Imponible
                  th(style="text-align: center; padding: 0.3em; color: black; background: lightgray") Débito Fiscal
                  th(style="text-align: center; padding: 0.3em; color: black; background: lightgray") Impuesto Retenido
                tr
                  th(style="text-align: center; padding: 0.3em; color: black; background: lightgray") Total : Ventas Internas No Gravadas
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") 0.00
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") 0.00
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") 0.00
                tr
                  th(style="text-align: center; padding: 0.3em; color: black; background: lightgray") Total Ventas de Exportación
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") 0.00
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") 0.00
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") 0.00
                tr
                  th(style="text-align: center; padding: 0.3em; color: black; background: lightgray") Total Ventas Internas Afectas solo Alicuota General
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") {{transaccionesDias.totalBaseImponible}}
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") {{transaccionesDias.totalImpuesto}}
                  td(style="border: 1px solid black ;text-align: center; padding: 0.3em; color: black") 0.00
                tr
                  th
                  td(style="border-top: 2px solid black ;text-align: center; padding: 0.3em; color: black") {{transaccionesDias.totalBaseImponible}}
                  td(style="border-top: 2px solid black ;text-align: center; padding: 0.3em; color: black") {{transaccionesDias.totalImpuesto}}
                  td(style="border-top: 2px solid black ;text-align: center; padding: 0.3em; color: black") 0.00
            p
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='dialog = false')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPDF")
            v-icon mdi-content-save
            | Imprimir
</template>

<script>
import Api from '@/services/methods'
import printJS from 'print-js'
export default {
  name: 'ReporteGerencia',
  data: () => ({
    dialog: false,
    dialog1: false,
    dialog2: false,
    modalDate1: false,
    modalDate2: false,
    nameEmpresa: '',
    master: '',
    hora: '',
    date: new Date().toISOString().substr(0, 10),
    fechaDesde: '',
    fechaHasta: '',
    headerVentas: [
      { text: 'FECHA', value: 'fecha' },
      { text: 'RIF', value: 'rif' },
      { text: 'DESCRIPCIÓN', value: 'descripcion' },
      { text: 'TIPO', value: 'tipo' },
      { text: 'DOCUMENTO', value: 'documento' },
      { text: 'NRO. CONTROL', value: 'noControl' },
      { text: 'NRO. DE FACTURA AFECTADA', value: 'nofac' },
      { text: 'TOTAL INCLUYENDO I.V.A(%)', value: 'totalIVA' },
      { text: 'TOTAL VENTAS INTERNAS NO GRAVADAS', value: 'totalnogra' },
      { text: 'BASE IMPONIBLE', value: 'baseImpo' },
      { text: ' % ALICUOTA', value: 'alicuota' },
      { text: 'IMPUESTO I.V.A(%)', value: 'impuesto' },
      { text: 'I.V.A(%) Retenido', value: 'impuestoret' }
    ],
    libroVentas: {},
    transaccionesDias: {}
  }),

  created () {
    this.fechaDesde = this.date
    this.fechaHasta = this.date

    if (this.$store.state.usuario.master) {
      this.master = this.$store.state.usuario.master
      for (let i = 0; i < this.$store.state.empresa.length; i++) {
        if (this.$store.state.empresa[i].idEmpresa === this.$store.state.idempresa.idempresa) {
          this.nameEmpresa = this.$store.state.empresa[i].nombre
        }
      }
    } else {
      this.master = this.$store.state.usuario._id
      for (let i = 0; i < this.$store.state.empresa.length; i++) {
        if (this.$store.state.empresa[i].idEmpresa === this.$store.state.idempresa.idempresa) {
          this.nameEmpresa = this.$store.state.empresa[i].nombre
        }
      }
    }
    // obtener la hota actual y formato 12h
    var localTime = new Date()

    var hours = localTime.getHours()
    var minutes = localTime.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    minutes = minutes < 10 ? '0' + minutes : minutes
    this.hora = hours + ':' + minutes + ' ' + ampm
  },

  methods: {
    imprimirPDF () {
      printJS({
        printable: 'reporteLibro',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        documentTitle: 'Libro de Ventas'
      })
    },

    numberPDF (num) {
      return Number.parseFloat(num).toFixed(2)
    },

    formato (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY')
    },

    getReporte () {
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => { this.$swal.showLoading() }
      })
      Api.get(`reportes/LibroVenta/${this.fechaDesde}/${this.fechaHasta}`)
        .then(res => {
          this.$swal.close()
          this.libroVentas = res.data.libroVentas
          this.transaccionesDias = res.data.transaccionesDias

          this.transaccionesDias.totalIncluyendoIVA = this.numberPDF(this.transaccionesDias.totalIncluyendoIVA)
          this.transaccionesDias.totalBaseImponible = this.numberPDF(this.transaccionesDias.totalBaseImponible)
          this.transaccionesDias.totalImpuesto = this.numberPDF(this.transaccionesDias.totalImpuesto)

          this.dialog = true
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    }

  }
}
</script>

<style lang="scss">
#reporteLibro {
  p {
    margin-bottom: 2%;
  }
  .v-data-table {
    border-bottom: 0px;
    background-color: transparent;
    .v-data-table-header {
      background-color: lightgray;
      tr {
       th {
         span {
           font-weight: bolder;
         }
       }
      }
    }
  }
  .theme--light.v-data-table thead tr:last-child th {
    border-bottom: 0px;
  }
  .theme--light.v-data-table thead tr th {
    color: black;
    font-weight: bold;
    font-size: 65%;
  }
  .theme--light.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row) {
    border-bottom: 0px;
  }
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child {
    border-bottom: 0px;
  }
}
</style>
